/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Unlock_Card2_DescInputs */

const en_home_unlock_card2_desc = /** @type {(inputs: Home_Unlock_Card2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact our Canadian support team, access FAQs, submit support requests, get travel alerts, and reach emergency assistance — whenever you need it.`)
};

const fr_home_unlock_card2_desc = /** @type {(inputs: Home_Unlock_Card2_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactez notre équipe de soutien canadienne, accédez aux FAQ, soumettez des demandes d'assistance, recevez des alertes de voyage et rejoignez l'assistance d'urgence — quand vous en avez besoin.`)
};

/**
* | output |
* | --- |
* | "Contact our Canadian support team, access FAQs, submit support requests, get travel alerts, and reach emergency assistance — whenever you need it." |
*
* @param {Home_Unlock_Card2_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_unlock_card2_desc = /** @type {((inputs?: Home_Unlock_Card2_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Unlock_Card2_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_unlock_card2_desc(inputs)
	return fr_home_unlock_card2_desc(inputs)
});